import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { RangedAnimationOptions } from "../../AnimationOptions";
export var SizeAnimation = /*#__PURE__*/function (_RangedAnimationOptio) {
  _inherits(SizeAnimation, _RangedAnimationOptio);

  var _super = _createSuper(SizeAnimation);

  function SizeAnimation() {
    var _this;

    _classCallCheck(this, SizeAnimation);

    _this = _super.call(this);
    _this.destroy = "none";
    _this.speed = 5;
    return _this;
  }

  _createClass(SizeAnimation, [{
    key: "size_min",
    get: function get() {
      return this.minimumValue;
    },
    set: function set(value) {
      this.minimumValue = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      if ((data === null || data === void 0 ? void 0 : data.size_min) !== undefined && data.minimumValue === undefined) {
        data.minimumValue = data.size_min;
      }

      _get(_getPrototypeOf(SizeAnimation.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      if (data.destroy !== undefined) {
        this.destroy = data.destroy;
      }
    }
  }]);

  return SizeAnimation;
}(RangedAnimationOptions);